var AdaptiveImage = require("../node_modules/react-native-web-image-loader/lib/modules/adaptiveImage.js").default;

module.exports = new AdaptiveImage({
    uri: __webpack_public_path__ + "icon-consult-in-progress.c78ba405.png","uri@2x": __webpack_public_path__ + "icon-consult-in-progress.cc08b0c3.png","uri@3x": __webpack_public_path__ + "icon-consult-in-progress.bfd6c461.png",
    width: 17,
    height: 18
});